import React, { useState, useEffect, useContext } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Input from "./../management/input";
import { getcustomer } from "../../services/wms";
import { useForm, Controller } from "react-hook-form";
import Select from "./../management/select";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from "react-toastify";

const schema = yup.object({
  code: yup.string().required("ระบุรหัสลูกค้า"),
});

const Modalchangcustomer = ({ isOpen, onCancel, onConfirm, list }) => {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
    control,
  } = useForm({ resolver: yupResolver(schema) });
  const [onsave, setonsave] = useState(false);
  const [formdata, setformdata] = useState({ do: "", weightno: "" });

  useEffect(() => {
    if (!isOpen) return;
    if (list && list.length > 0) {
      setformdata({ do: list[0].Delivery_No, weightno: list[0].Weight_No });

      reset({
        do: list[0].Delivery_No,
      });
    } else {
      setformdata({ do: "", weightno: "" });
    }
  }, [list.length, isOpen]);

  const onSubmit = (data) => {
    const saveDoc = {
      weightno: formdata.weightno,
      olddeliveryno: formdata.do,
      newdeliveryno: data.code,
    };

    doSubmit(saveDoc);
  };

  const doSubmit = async (doc) => {
    setonsave(true)
    const { data: result } = await getcustomer(doc);
    if (result.status === "success") {
      toast.success("บันทึกเสร็จเรียบร้อย");
      setonsave(false)
      onConfirm();
    }
  };

  const handleCancle = (e) => {
    onCancel(false);
  };

  return (
    <div>
      <Modal
        className="modal-dialog modal-xl"
        isOpen={isOpen}
        toggle={onCancel}
      >
        <ModalHeader>
          <p className=" text-primary me-2  fs-2 fw-bold ">
            <i className="bi bi-box me-2" />
            เปลี่ยนลูกค้า
            {list > 0 && list[0].Weight_No}{" "}
          </p>
        </ModalHeader>
        <ModalBody>
          <>
            {list &&
              list.length > 0 &&
              list.map((item, index) => (
                <div className="modal-body p-0" key={index}>
                  <div className="modal-body">
                    <div className="row" style={{ fontSize: 14 }}>
                      <div className=" col-lg-6">
                        <div>
                          <h6>
                            รหัสลูกค้า
                            <small style={{ fontSize: 14 }}>
                              {item.Customer_Code}
                            </small>{" "}
                          </h6>
                        </div>
                        <div>
                          <h6>
                            ชื่อลูกค้า :
                            <small style={{ fontSize: 14 }}>
                              {item.Customer_name}
                            </small>
                          </h6>
                        </div>
                        <div>
                          <h6>
                            ประเภทสินค้า :
                            <small style={{ fontSize: 14 }}>
                              {item.Type_name}
                            </small>
                          </h6>
                        </div>
                        <div>
                          <h6>
                            ชื่อสินค้า :
                            <small style={{ fontSize: 14 }}>
                              {item.Product_name}
                            </small>
                          </h6>
                        </div>
                        <div>
                          <h6>
                            ประเภทรถ :
                            <small style={{ fontSize: 14 }}>
                              {item.TruckType}
                            </small>
                          </h6>
                        </div>
                        <div className="row">
                          <div className="col-auto">
                            <h6>
                              ทะเบียนรถ :
                              <small style={{ fontSize: 14 }}>
                                {item.First_driven_no} :{" "}
                                {item.First_driven_prov}
                              </small>
                            </h6>
                          </div>
                          <div className="col-auto">
                            <h6>
                              ทะเบียนหาง :
                              <small style={{ fontSize: 14 }}>
                                {item.Second_driven_no}:{" "}
                                {item.Second_driven_prov}
                              </small>
                            </h6>
                          </div>
                        </div>

                        <div />
                      </div>
                      <div className=" col-lg-6">
                        <div>
                          <h6>
                            วัตถุประสงค์ :
                            <small style={{ fontSize: 14 }}>
                              {item.aim_name}
                            </small>
                          </h6>
                        </div>
                        <div>
                          <h6>
                            วันที่ทำรายการ : 22-05-2022
                            <small style={{ fontSize: 14 }}>
                              {/* {item.Daterecord} */}
                              {/* {moment(item.Daterecord, "YYYY-MM-DD").format("YYYY-MM-DD")} */}
                            </small>
                          </h6>
                        </div>
                        <div>
                          <h6>
                            น้ำหนักชั่งเข้า :
                            <span className="badge rounded-pill bg-success ms-2">
                              {item.Receive_weightin}
                            </span>
                          </h6>
                        </div>
                        <div>
                          <h6>
                            น้ำหนักชั่งออก :
                            <span className="badge rounded-pill bg-primary ms-2">
                              {item.Receive_weightout}
                            </span>
                          </h6>
                        </div>
                        <div>
                          <h6>
                            น้ำหนักสุทธิ :
                            <span className="badge rounded-pill bg-warning text-dark ms-2">
                              {item.Receive_weightnet}
                            </span>
                          </h6>
                        </div>

                        <div />
                      </div>
                      <div className="col-sm-6 col-xs-12 mt-4">
                        <Input
                          icon="bi bi-book-fill text-primary me-2"
                          label="ชื่อเก่าลูกค้า"
                          name="do"
                          register={register}
                          required
                          errors={errors.codepp}
                          disabled
                        />
                      </div>
                      <div className="col-sm-6 col-xs-12 mt-4">
                        <Input
                          icon="bi bi-book-fill text-danger me-2"
                          label="เลขที่ DO ใหม่"
                          name="code"
                          register={register}
                          required
                          errors={errors.codepp}
                        />
                      </div>
                      
                    </div>
                  </div>
                </div>
              ))}
          </>
        </ModalBody>
        <ModalFooter>
          <div className="col-auto">
            <div className="row">
              <div className=" col-auto ">
                <Button color="primary" onClick={handleSubmit(onSubmit)}>
                  Confirm
                </Button>
              </div>
              <div className="col-auto ">
                <Button color="secondary" onClick={handleCancle}>
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Modalchangcustomer;
